import React                   from 'react';
import { Button }              from 'antd';
import { Link }                from 'react-router-dom';
import PublicLayout            from 'containers/Security/PublicLayout';
import ResetPasswordTokenModel from 'models/ResetPasswordTokenModel';
import InputPassword           from 'components/App/IntlInputPassword';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { messageErrorIntl }    from 'utils/messageIntl';

const findGetParameter = (parameterName: string) => {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach(item => {
      tmp = item.split('=');
      if (tmp[0] === parameterName) {
        result = decodeURIComponent(tmp[1]);
      }
    });
  return result;
};

export default class PasswordRecover extends React.Component {
  public state = {
    done: false,
    errors: [],
    plainPassword: '',
    plainPasswordConfirmation: '',
  };

  public componentDidMount() {
    if (!findGetParameter('t')) {
      messageErrorIntl("L'url est invalide.");
    }
  }

  public render() {
    return (
      <PublicLayout>
        <h2>
          <FormattedMessageWrapper id="Ré-initialisation mot de passe" />
        </h2>
        <br />
        {this.state.done ? (
          <p>
            <FormattedMessageWrapper id="Votre mot de passe a bien été ré-initialisé, vous pouvez vous connecter !" />
          </p>
        ) : (
          <>
            {this.state.errors.length > 0 && (
              <p>
                {this.state.errors.map((error, index) => (
                  <div key={index} style={{ color: '#e74c3c' }}>{error}</div>
                ))}
              </p>
            )}
            <p>
              <b>
                <FormattedMessageWrapper id="Nouveau mot de passe :" />
              </b>
            </p>
            <p>
              <InputPassword
                onChange={event => this.setState({ plainPassword: event.target.value })}
                placeholder="Mot de passe"
                value={this.state.plainPassword}
              />
            </p>
            <p>
              <b>
                <FormattedMessageWrapper id="Confirmation nouveau mot de passe :" />
              </b>
            </p>
            <p>
              <InputPassword
                onChange={event =>
                  this.setState({
                    plainPasswordConfirmation: event.target.value,
                  })
                }
                placeholder="Confirmation mot de passe"
                value={this.state.plainPasswordConfirmation}
              />
            </p>
            <p style={{ marginTop: 10 }}>
              <Button htmlType="button" onClick={this.handleSubmit}>
                <FormattedMessageWrapper id="Envoyer" />
              </Button>
            </p>
          </>
        )}

        <br />

        <Link to="/login">
          <FormattedMessageWrapper id="Retour" />
        </Link>
      </PublicLayout>
    );
  }

  private handleSubmit = async () => {
    if (this.state.plainPassword !== this.state.plainPasswordConfirmation) {
      this.setState({
        errors: [<FormattedMessageWrapper id="Confirmation du mot de passe incorrecte." key="confirmation_invalid" />],
      });
      return;
    }

    const resetPasswordTokenModel = new ResetPasswordTokenModel();
    const options = {
      data: JSON.stringify({
        plainPassword: this.state.plainPassword,
        token: findGetParameter('t'),
      }),
      headers: {
        'content-type': 'application/json',
      },
    };

    try {
      await resetPasswordTokenModel.save(options);
      this.setState({ done: true });
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };
}
